import React from 'react';
import { fx } from '../../fx.js';
import { BODY } from '../../primitives.js';

const h = React.createElement;

const MK = {
  square: { background: 'var(--coral)' }, quarter: { background: 'var(--gold)', borderRadius: '100% 0 0 0' },
  dot: { background: 'var(--lime)', borderRadius: '50%' }, half: { background: 'var(--gold)', borderRadius: '100% 100% 0 0', height: 11 },
  pill: { background: 'var(--lime)', borderRadius: 20, width: 34 }, ring: { background: 'transparent', borderRadius: '50%', borderWidth: 4 }
};

const SEQ = ['square', 'quarter', 'dot', 'pill', 'quarter', 'square', 'half', 'dot', 'ring', 'quarter'];

/**
 * The mark vocabulary as a looping strip. Pauses on hover/focus, has a pause button, starts paused
 * under reduced motion. Click a shape to turn it.
 *
 * @param {object} p
 * @param {Array<'square'|'quarter'|'dot'|'half'|'pill'|'ring'>} [p.shapes]
 * @param {number} [p.speed]
 * @param {number} [p.height]
 * @param {string} [p.label]
 * @param {React.CSSProperties} [p.style]
 */
export function Marquee({ shapes = SEQ, speed = 38, height = 44, label = 'Decorative strip', style }) {
  const [paused, setPaused] = React.useState(() => !!(fx.reduced && fx.reduced()));
  const [turns, setTurns] = React.useState({});
  const unit = (s, i, copy) => {
    const k = copy + ':' + i, t = turns[k] || 0;
    const base = { width: 22, height: 22, border: '2px solid var(--oninkbg)', boxSizing: 'border-box', flex: 'none', cursor: 'pointer', transform: `rotate(${t * 90}deg)`, transition: 'transform 260ms var(--ease-pop)' };
    if (s === 'tri') return h('span', { key: k, onClick: () => setTurns({ ...turns, [k]: t + 1 }), style: { width: 0, height: 0, borderLeft: '12px solid transparent', borderRight: '12px solid transparent', borderBottom: '21px solid var(--oninkbg)', flex: 'none', cursor: 'pointer', transform: base.transform, transition: base.transition } });
    return h('span', { key: k, onClick: () => setTurns({ ...turns, [k]: t + 1 }), style: { ...base, ...MK[s] } });
  };
  const row = (copy) => h('div', { 'aria-hidden': copy === 'b', style: { display: 'flex', alignItems: 'center', gap: 22, paddingRight: 22, flex: 'none' } }, shapes.concat(['tri']).map((s, i) => unit(s, i, copy)));
  return h('div', { role: 'group', 'aria-label': label, className: 'gx-marquee' + (paused ? ' is-paused' : ''), style: { position: 'relative', display: 'flex', alignItems: 'center', height, overflow: 'hidden', background: 'var(--inkbg)', border: '2px solid var(--ink)', borderRadius: 'var(--r-control)', boxShadow: 'var(--el-2)', ...style } },
    h('div', { className: 'gx-track', style: { display: 'flex', animationDuration: `${Math.max(6, (shapes.length * 44) / speed)}s` } }, row('a'), row('b')),
    h('button', { type: 'button', onClick: () => setPaused(!paused), 'aria-label': paused ? 'Play strip' : 'Pause strip', title: paused ? 'Play' : 'Pause', style: { position: 'absolute', right: 6, top: '50%', marginTop: -12, height: 24, padding: '0 8px', border: '1.5px solid var(--ink)', borderRadius: 7, background: 'var(--card)', color: 'var(--tx)', fontFamily: BODY, fontSize: 10.5, fontWeight: 800, cursor: 'pointer', zIndex: 1 } }, paused ? '▶' : '❚❚'));
}
